module.exports = {
  darkMode: 'class',
  prefix: 'tw-',
  content: [
    './assets/**/*.js',
    './assets/**/*.vue',
    './src/**/*.twig',
    './src/Vacatia/AdminBundle/Resources/**/*.twig',
    './src/Vacatia/CoreBundle/Resources/**/*.twig',
    './src/Vacatia/RentalBundle/Resources/**/*.twig',
    './templates/**/*.twig',
    './node6/assets/js/rental-es6/**/*.js',
  ],
  theme: {
    container: {
      center: true,
    },
    extend: {
      letterSpacing: {
        hyper: '.15rem',
      },
      backgroundPosition: {
        'pos-center-bottom': 'center bottom',
        'pos-subscribe-section': 'calc(50% - 1rem) bottom',
        'pos-md-subscribe-section': 'calc(50% - 26rem) bottom',
        'pos-subscribe-hero': 'calc(50% - 1rem) bottom',
        'pos-md-subscribe-hero': 'calc(50% - 22rem) bottom',
      },
      backgroundSize: {
        'size-subscribe-section': 'auto 9.9375rem',
        'size-md-subscribe-section': 'auto 21.6875rem',
        'size-subscribe-hero': '35rem auto',
        'size-md-subscribe-hero': 'auto 21.625rem',
        'size-where-can-i-go-section': 'auto 8rem',
        'size-md-where-can-i-go-section': 'auto',
        'size-auth-modal': '100% auto',
        'size-md-auth-modal': '154% auto',
      },
      colors: {
        'vacatia-blue': {
          DEFAULT: '#2e95ec',
          light: '#499ef1',
          lighter: '#d5eafb',
          lighterer: '#e0effc',
          lightest: '#eaf4fd',
        },
        'vacatia-orange': {
          DEFAULT: '#ed6f2d',
          light: '#F0612F',
          dark: '#f1612f',
        },
        'vacatia-green': {
          light: '#66cc66',
          dark: '#369336',
        },
        'vacatia-plus': {
          DEFAULT: '#1c3c9b'
        },
        'owner': {
          blue: '#125d9d',
          error: '#cc0000',
        },

        'error-red': '#f72600',
        'f1': '#f1f1f1',
        'f2': '#f2f2f2',
        'eee': '#eeeeee',
        'e6': '#e6e6e6',
        'd5': '#d5d5d5',
        'ccc': '#cccccc',
        '999': '#999999',
        '666': '#666666',
        '333': '#333333',
        '093': '#009933',
        'c30': '#CC3300',

        // Accessible Palettes
        // Blue (Primary)
        'a11y-blue': {
          50: '#F7FAFF',
          100: '#E1F0FD',
          200: '#B5DAF7',
          300: '#87C4F3',
          400: '#58ACEE',
          500: '#2C92E1',
          600: '#2478B8',
          700: '#1F639B',
          800: '#18507A',
          900: '#133F60',
          950: '#091D2E',
        },
        // Green (Success)
        'a11y-green': {
          50: '#F7FBF5',
          100: '#E3F2DF',
          200: '#BEDDAD',
          300: '#97C97E',
          400: '#70B44D',
          500: '#439D1E',
          600: '#318211',
          700: '#286C0C',
          800: '#205608',
          900: '#194405',
          950: '#0B2000',
        },
        // Yellow (Warning)
        'a11y-yellow': {
          50: '#FFFAE7',
          100: '#FFECAB',
          200: '#FFCD2C',
          300: '#E4B422',
          400: '#C79E1B',
          500: '#A98416',
          600: '#8A6F10',
          700: '#745B0C',
          800: '#5B4807',
          900: '#483905',
          950: '#221B00',
        },
        // Red (error)
        'a11y-red': {
          50: '#FEF9F9',
          100: '#FDE9E9',
          200: '#F5CACA',
          300: '#F0AAAA',
          400: '#EB8888',
          500: '#E45E60',
          600: '#DC252B',
          700: '#B81E23',
          800: '#92181B',
          900: '#751315',
          950: '#3A0A0A',
        },
        // Neutral
        'a11y-neutral': {
          50: '#FAFAFA',
          100: '#EDEDED',
          200: '#D4D5D4',
          300: '#BDBCBC',
          400: '#A4A4A4',
          500: '#8B8B8B',
          600: '#727272',
          700: '#5F5F5F',
          800: '#4B4B4B',
          900: '#3B3B3A',
          950: '#1B1B1B',
        },
      },
      flex: {
        '2': '2 2 0%',
        '3': '3 3 0%',
        '4': '4 4 0%',
        '5': '5 5 0%',
        '6': '6 6 0%',
        '7': '7 7 0%',
        '8': '8 8 0%',
        '9': '9 9 0%',
        '10': '10 10 0%',
        '11': '11 11 0%',
        '12': '12 12 0%',
      },
      fontFamily: {
        sans: '"Montserrat", Helvetica, Arial, sans-serif',
        'sans-legacy': '"Open Sans", Helvetica, Arial, sans-serif',
      },
      fontSize: {
        'xxs': '0.625rem',
        '15': '0.9375rem',
      },
      lineHeight: {
         '16': '4rem',
      },
      width: {
        'xxs': '360px',
        'xs': '414px',
        'sm': '640px',
        'md': '768px',
        'lg': '1024px',
        'xl': '1280px',
        '2xl': '1536px',
      },
    },
    screens: {
      'xxs': '360px',
      'xs': '414px',
      'sm': '640px',
      'md': '768px',
      'lg': '1024px',
      'xl': '1280px',
      '2xl': '1536px',
      '3xl': '1680px',

      // vertical breakpoints are "desktop first"
      'v-xs': { raw: '(max-height: 320px)' },
      'v-sm': { raw: '(max-height: 480px)' },
      'v-md': { raw: '(max-height: 600px)' },
      'v-lg': { raw: '(max-height: 768px)' },

      'v-min-xs': { raw: '(min-height: 320px)' },
      'v-min-sm': { raw: '(min-height: 480px)' },
      'v-min-md': { raw: '(min-height: 600px)' },
      'v-min-lg': { raw: '(min-height: 768px)' },
      'v-min-xl': { raw: '(min-height: 1024px)' },
    },
  },
  corePlugins: {
    preflight: false,
  },
  plugins: [
    require('@tailwindcss/aspect-ratio'),
    require('@tailwindcss/line-clamp'),
  ],
}
